


















































import { Component, Prop, Mixins } from 'vue-property-decorator';
import {Actions, Mutations, ViewModes} from '@/ts/store/Constants';
import EventLogMethods from '@/mixins/EventLogMethods.vue';
import DateMethods from '@/mixins/DateMethods.vue';
import LogNotification from '@/ts/instances/notifications/LogNotification';
import ProfileImage from '@/components/Media/ProfileImage.vue';

@Component({
    name: 'TenantNotificationItem',
    components: {
        ProfileImage,
    },
})
export default class TenantNotificationItem extends Mixins(EventLogMethods, DateMethods) {
    @Prop({ required: true }) public log: LogNotification;

    constructor() {
        super();
    }

    get title(): string {
        switch (this.log.eventLog.message.type) {
            case 'TICKET_MESSAGE_REPLY':
            case 'TICKET_ASSIGNEE':
            case 'TICKET_STATUS':
            case 'TICKET_PRIORITY':
            case 'TICKET_MESSAGE':
                return this.log.eventLog.ticket.title;
            case 'BOOKING_CANCELED':
                return this.$t('event-log.cancellation', 'Cancellation');
            case 'CONVERSATION_CONVERTED_TO_TICKET':
                return this.$t('event-log.message-converted-to-ticket', 'Message converted to ticket');
            case 'CONVERSATION_CLOSED':
                return this.$t('event-log.message-marked-as-closed', 'Message marked as closed');
            case 'MESSAGE_NEW':
                return this.$t('event-log.you-got-a-new-message', 'You got a new message');
            case 'MESSAGE_REPLY':
                return this.$t('event-log.new-message-reply', 'New message reply');
            default:
                return this.log.text;
        }
    }

    get subTitle(): string {
        switch (this.log.eventLog.message.type) {
            case 'TICKET_MESSAGE_REPLY':
                return this.$t('event-log.new-chat-reply', 'New chat reply');
            case 'TICKET_MESSAGE':
                return this.$t('event-log.you-got-a-message', 'You got a message');
            case 'TICKET_ASSIGNEE':
            case 'TICKET_STATUS':
            case 'TICKET_PRIORITY':
                return this.log.title;
            case 'BOOKING_CANCELED':
                return `${this.$t('shared-facilities.booking', 'Booking')}: ${this.log.eventLog.booking.name}`;
            case 'CONVERSATION_CONVERTED_TO_TICKET':
            case 'CONVERSATION_CLOSED':
                return `${this.$t('general.by', 'By')}: ${ this.log.authorName }`;
            case 'MESSAGE_NEW':
                return `${this.$t('general.from', 'From')}: ${ this.log.authorName }`;
            case 'MESSAGE_REPLY':
                return `${this.$t('general.reply-from', 'Reply from')}: ${ this.log.authorName }`;
            default:
                return this.log.title;
        }
    }

    public markAsSeen() {
        if (this.log.seen) {
            return false;
        }

        this.$store.dispatch(Actions.MARK_TENANT_NOTIFICATION_AS_SEEN, this.log.id);
    }

    public open() {
        this.markAsSeen();

        switch (this.log.eventLog.message.type) {
            case 'TICKET_MESSAGE_REPLY':
            case 'TICKET_MESSAGE':
            case 'TICKET_ASSIGNEE':
            case 'TICKET_STATUS':
            case 'TICKET_PRIORITY':
            case 'CONVERSATION_CONVERTED_TO_TICKET':
                const ticketId = this.log.eventLog.message.type !== 'CONVERSATION_CONVERTED_TO_TICKET'
                    ? this.log.eventLog.message.ticket_id
                    : this.log.eventLog.ticket.id;

                const openChat = ['TICKET_MESSAGE_REPLY', 'TICKET_MESSAGE'].includes(this.log.eventLog.message.type);

                this.$router.push({ name: 'tickets'});
                this.$store.dispatch(Actions.FETCH_USER_CURRENT_TICKET, {id: ticketId, chat: openChat})
                    .then(() => {
                        this.$store.dispatch(Actions.SUBMIT_GLOBAL_OVERLAY_CONFIG, {}).then(() => {
                            this.$store.dispatch(Actions.SUBMIT_GLOBAL_OVERLAY_VISIBILITY, false);
                        });
                    });
                break;
            case 'BOOKING_CANCELED':
                this.$router.push({
                    name: 'shared-facilities',
                    params: { bookingId: this.log.eventLog.message.booking_id },
                    query: { bookingId: this.log.eventLog.message.booking_id },
                });
                this.$store.dispatch(Actions.SUBMIT_GLOBAL_OVERLAY_CONFIG, {}).then(() => {
                    this.$store.dispatch(Actions.SUBMIT_GLOBAL_OVERLAY_VISIBILITY, false);
                });
                break;
            case 'CONVERSATION_CLOSED':
                this.$router.push({name: 'messages'});
                this.$store.commit(Mutations.SET_VISIBLE_CONVERSATIONS_STATUS, 'closed');

                this.$store.dispatch(Actions.SUBMIT_GLOBAL_OVERLAY_CONFIG, {}).then(() => {
                    this.$store.dispatch(Actions.SUBMIT_GLOBAL_OVERLAY_VISIBILITY, false);
                });

                break;
            case 'MESSAGE_NEW':
            case 'MESSAGE_REPLY':
                const conversation = this.$store.getters['Messages/getConversation'](this.log.eventLog.message.conversation_id);
                this.$store.commit(Mutations.UPDATE_ACTIVE_CONVERSATION, conversation.id);

                if (conversation.hasUnseenMessages === true) {
                    this.$store.dispatch(Actions.MARK_ACTIVE_CONVERSATION_AS_SEEN);
                }

                this.$store.commit(Mutations.SET_MESSAGES_VIEW_MODE, ViewModes.Messages.Messages);

                this.$router.push({
                    name: 'messages',
                    params: { conversationId: conversation.id.toString() },
                });

                this.$store.dispatch(Actions.SUBMIT_GLOBAL_OVERLAY_CONFIG, {}).then(() => {
                    this.$store.dispatch(Actions.SUBMIT_GLOBAL_OVERLAY_VISIBILITY, false);
                });
                break;
            default:
                return false;
        }
    }
}
